export const PAYMENT_ENUMS = ["CASH","CHECK","TRANSFER","CARD","DEPOSIT","EFFET"];

export const PAYMENT_TRIPLES = {
  CASH:     { fr: "Bon de caisse",    en: "Cash" },
  CHECK:    { fr: "Chèque",           en: "Cheque" },
  TRANSFER: { fr: "Virement",         en: "Transfer" },
  CARD:     { fr: "Carte bancaire",   en: "Card" },
  DEPOSIT:  { fr: "Versement",        en: "Deposit" },
  EFFET:    { fr: "Effet",            en: "Bill of exchange" }, 
};

const NORM = (s) =>
  (s ?? "")
    .toString()
    .normalize("NFD").replace(/\p{Diacritic}+/gu, "")
    .toLowerCase().replace(/\s+/g, " ").trim();

const LABEL_TO_ENUM = new Map(
  Object.entries(PAYMENT_TRIPLES).flatMap(([code, { fr, en }]) => {
    const pairs = [
      [NORM(fr), code],
      [NORM(en), code],
      [NORM(code), code],
    ];
    return pairs;
  })
);

function pickRowKey(row) {
  return row?.code ?? row?.key ?? row?.name ?? row?.value ?? row?.label ?? row;
}

export function enumsFromServer(rows) {
  const seen = new Set();
  const out = [];
  for (const r of rows ?? []) {
    const raw = pickRowKey(r);
    const norm = NORM(raw);
    let code =
      (typeof raw === "string" && PAYMENT_ENUMS.includes(raw)) ? raw
      : LABEL_TO_ENUM.get(norm);

    if (code && !seen.has(code)) {
      seen.add(code);
      out.push(code);
    }
  }
  return out; 
}

export function resolveLang(input) {
  const raw = typeof input === "string" ? input : input?.resolvedLanguage || input?.language;
  return (raw ?? "").toLowerCase().startsWith("fr") ? "fr" : "en";
}

export function labelFor(code, t, lang) {
  const key = `payment_mode.${code}`; 
  const translated = typeof t === "function" ? t(key) : key;
  if (translated === key) return PAYMENT_TRIPLES[code]?.[lang] ?? code;
  return translated;
}

export function buildPaymentOptions({ enabledEnums, t, lang, fallbackToAll = false }) {
  const l = resolveLang(lang);
  let list;
  if (Array.isArray(enabledEnums)) {
    list = enabledEnums.filter((c) => PAYMENT_TRIPLES[c]);
  } else {
    list = fallbackToAll ? PAYMENT_ENUMS : [];
  }
  return list.map((code) => ({ value: code, label: labelFor(code, t, l) }));
}

export function buildPaymentOptionsFromServer(rows, { t, lang, fallbackToAll = false } = {}) {
  const enabled = enumsFromServer(rows);
  return buildPaymentOptions({ enabledEnums: enabled, t, lang, fallbackToAll });
}


